import React from "react";
import Settings from "./Settings";
import {useGetSettingsQuery, useUpdateSettingsMutation} from "../../../services/settings";
import {toast} from "react-toastify";
import {CircularProgress} from "@mui/material";

export default function SettingsPage() {

  const [updateSettingsApi] = useUpdateSettingsMutation();

  const {data,isLoading,isError} = useGetSettingsQuery();

  const onSave = async (value: string) => {
    try {
      await updateSettingsApi({replyTo: value}).unwrap();
    } catch (e) {
      toast.error("Failed to save settings, please try again.");
    }
  }

  if (isLoading) {
    return <CircularProgress />
  }

  if (isError) {
    return <div>Failed to load settings, please try again.</div>
  }
  const email = data?.replyTo;
  console.log("settings:", data);

  return (<Settings email={email ? email : ""} onSave={onSave}/>)
}